import { render, staticRenderFns } from "./formForm56_1.vue?vue&type=template&id=391ce28a&scoped=true"
import script from "./formForm56_1.vue?vue&type=script&lang=js"
export * from "./formForm56_1.vue?vue&type=script&lang=js"
import style0 from "./formForm56_1.vue?vue&type=style&index=0&id=391ce28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391ce28a",
  null
  
)

export default component.exports